<template>
	<AppDialog :closeRight="'-10'" :closeTop="'-30'" disableMaxWidth dialogName="HelpBuildingDialog" width="730px">
		<div class="dialog-cont display-flex flex-wrap px-5 pt-6 pb-4 text-center">
			<div class="flex-col-12 display-flex flex-wrap">
				<div class="flex-col-12">
					<IdeaFormattedTitle :idea="idea" />
				</div>
				<div class="flex-col-12 pt-4">
					<span class="title">Let's make it happen.</span>
				</div>
			</div>
			<div class="flex-col-12 flex-space-around--center">
				<AskPlyHelpBox class="flex-col-5 box" @click="onBoxClick" :idea="idea" />
				<AskCommunityHelpBox class="flex-col-5 box" @click="onBoxClick" />
			</div>
			<div class="flex-col-12 flex-center--end">
				<span class="text-underline" role="button" @click="cancel"><h2 class="reg">Cancel</h2></span>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AskPlyHelpBox from './AskPlyHelpBox.vue';
import AskCommunityHelpBox from './AskCommunityHelpBox.vue';
import { useIdea } from '@/store/modules/inspirationCenter/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import IdeaFormattedTitle from '@/components/dialogs/IdeaDialog/IdeaFormattedTitle.vue';
export default {
	name: 'HelpBuildingIdeaDialog',
	components: {
		AppDialog,
		AskPlyHelpBox,
		IdeaFormattedTitle,
		AskCommunityHelpBox,
	},
	props: { ideaId: { type: String }, dialogPromiseHandlers: { type: Object } },
	methods: {
		onBoxClick() {
			this.close();
		},
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		cancel() {
			this.close();
		},
	},
	computed: {
		...mapGettersShorthand({ useIdea }),
		idea() {
			return this.useIdea(this.ideaId);
		},
	},
};
</script>

<style lang="scss" scoped>
.dialog-cont {
	height: 540px;
	.title {
		font-size: 25px !important;
		font-weight: 600;
	}
	.box {
		height: 256px;
	}
}
</style>
